<template>
  <div>
      <b-form-group label-align="right" :label="$t('Is link active')" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-checkbox disabled v-model="serviceStats.isActive"/>
      </b-form-group>
      <b-form-group label-align="right" :label="$t('Fee recalc start')" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-form-input type="text" disabled v-model="serviceStats.feeStart"/>
      </b-form-group>
      <b-form-group label-align="right" :label="$t('Fee recalc duration')" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-form-input type="text" disabled v-model="serviceStats.feeDuration"/>
      </b-form-group>
      <b-form-group label-align="right" :label="$t('Traffic recalc start')" label-cols="4" label-cols-xl="4" label-cols-md="4" v-if="currentService.service_type === 3 || currentService.service_type === 6">
        <b-form-input type="text" disabled v-model="serviceStats.ipTelStart"/>
      </b-form-group>
      <b-form-group label-align="right" :label="$t('Traffic recalc duration')" label-cols="4" label-cols-xl="4" label-cols-md="4" v-if="currentService.service_type === 3 || currentService.service_type === 6">
        <b-form-input type="text" disabled v-model="serviceStats.ipTelDuration"/>
      </b-form-group>
      <b-form-group label-align="right" :label="$t('Charged')" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-form-input type="text" disabled v-model="serviceStats.charged_in_curr_period"/>
      </b-form-group>
      <b-form-group label-align="right" :label="$t('Repaid')" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-form-input type="text" disabled v-model="serviceStats.repaid_in_curr_period"/>
      </b-form-group>
    <b-row>
      <b-col cols="8"/>
      <b-col>
        <md-button @click.stop="hideFormCharged" class="md-raised" >{{ $t('Ok') }}</md-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  props: {
    currentService: null
  },
  methods: {
    hideFormCharged () {
      this.$emit('hideFormCharged')
    }
  },
  computed: {
    serviceStats () {
      let tmp = {}
      if (this.$store.getters['Users/PERIODIC_SERVICE_LINK_STATS']) {
        tmp = this.$store.getters['Users/PERIODIC_SERVICE_LINK_STATS']
        tmp.charged_in_curr_period = Number.parseFloat(tmp.charged_in_curr_period).toFixed(3)
        if (tmp.is_planning) {
          tmp.isActive = false
        } else {
          tmp.isActive = true
        }
        if (tmp.fee_recalc.start) {
          tmp.feeStart = this.$root.getMomentWithTZDelta(Number(tmp.fee_recalc.start)).format('YYYY-MM-DD HH:mm')
        } else {
          tmp.feeStart = this.$i18n.t('NA')
        }
        tmp.feeDuration =
      tmp.fee_recalc.duration / 86400 + this.$i18n.t('d. ') +
      tmp.fee_recalc.duration / 3600 + this.$i18n.t('h. ') +
      tmp.fee_recalc.duration / 60 + this.$i18n.t('m.')
        if (this.currentService.service_type === 3) {
          if (tmp.ip_recalc.start) {
            tmp.ipTelStart = this.$root.getMomentWithTZDelta(Number(tmp.ip_recalc.start)).format('YYYY-MM-DD HH:mm')
          } else {
            tmp.ipTelStart = this.$i18n.t('NA')
          }
          tmp.ipTelDuration =
        tmp.ip_recalc.duration / 86400 + this.$i18n.t('d. ') +
        tmp.ip_recalc.duration / 3600 + this.$i18n.t('h. ') +
        tmp.ip_recalc.duration / 60 + this.$i18n.t('m.')
        }
        if (this.currentService.service_type === 6) {
          if (tmp.tel_recalc.start) {
            tmp.ipTelStart = this.$root.getMomentWithTZDelta(Number(tmp.tel_recalc.start)).format('YYYY-MM-DD HH:mm')
          } else {
            tmp.ipTelStart = this.$i18n.t('NA')
          }
          tmp.ipTelDuration =
        tmp.tel_recalc.duration / 86400 + this.$i18n.t('d. ') +
        tmp.tel_recalc.duration / 3600 + this.$i18n.t('h. ') +
        tmp.tel_recalc.duration / 60 + this.$i18n.t('m.')
        }
      }
      return tmp
    }
  },
  mounted () {
    this.$store.dispatch('Users/GET_PERIODIC_SERVICE_LINK_STATS', this.currentService.service_link_id)
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/usersAndGroups/detail/serviceLinks/formCharged.vue